module.exports = __webpack_public_path__ + "img/logo.2e8a8def.png";